var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sub_bucket",
    "data-name": "Sub bucket",
    transform: "translate(-480 -127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2953",
    "data-name": "Rectangle 2953",
    transform: "translate(480 127)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_12363",
    "data-name": "Path 12363",
    transform: "translate(481 130.328)",
    fill: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    opacity: 0.499
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.256-.328H7.432l1.5,1.1,1.263.841H16.9a1.256,1.256,0,0,1,1.256,1.256l.02,10.035A1.256,1.256,0,0,1,16.92,14.16H1.256A1.256,1.256,0,0,1,0,12.9V.927A1.256,1.256,0,0,1,1.256-.328Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.5 1.171927452087402 L 1.5 12.65985774993896 L 16.67548370361328 12.65985774993896 L 16.65632057189941 3.113607406616211 L 10.19511985778809 3.113607406616211 C 9.899179458618164 3.113607406616211 9.609859466552734 3.026067733764648 9.363559722900391 2.862007141113281 L 8.100520133972168 2.020697593688965 C 8.081679344177246 2.008147239685059 8.063129425048828 1.995177268981934 8.044879913330078 1.98178768157959 L 6.940822601318359 1.171927452087402 L 1.5 1.171927452087402 M 1.255498886108398 -0.3280725479125977 L 7.431980133056641 -0.3280725479125977 L 8.932080268859863 0.7722969055175781 L 10.19511985778809 1.613607406616211 L 16.90032005310059 1.613607406616211 C 17.59371948242188 1.613607406616211 18.15583038330078 2.175717353820801 18.15583038330078 2.869117736816406 L 18.17597961425781 12.90435695648193 C 18.17597961425781 13.59775733947754 17.61387062072754 14.15985774993896 16.92047882080078 14.15985774993896 L 1.255498886108398 14.15985774993896 C 0.5621089935302734 14.15985774993896 0 13.59775733947754 0 12.90435695648193 L 0 0.9274377822875977 C 0 0.2340373992919922 0.5621089935302734 -0.3280725479125977 1.255498886108398 -0.3280725479125977 Z",
    stroke: "none",
    fill: "#3d3d3d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBucket);
export default __webpack_public_path__ + "static/media/bucket.9ebb8ba77615bec585947fd04f10ab72.svg";
export { ForwardRef as ReactComponent };